import Store from 'lightningjs-redux';
import { getScreenSaverData, getScreenSaverIsLocked } from '../../logic/screenSaver/screenSaver.selectors';
import { checkLayoutsNotEqual } from '../../logic/screenSaver/screenSaver.utils';

const mapControllers = instance => ({
  screenSaverData: {
    selector: getScreenSaverData,
    condition: ({ previousProp, currentProp }) => checkLayoutsNotEqual(previousProp, currentProp),
    callback: value => {
      instance.items = value.items;
    },
  },
  isLocked: {
    selector: getScreenSaverIsLocked,
    callback: isLocked => {
      instance.isLocked = isLocked;
    },
  },
});

export default Store.control(mapControllers);
